
import './modernizr';


let continue_without_support = false;
let supports_local_storage = false;
const local_storage_key = 'veo.continue-unsupported';
try {
  supports_local_storage = !!window.localStorage;
  if (window.localStorage && typeof (window.localStorage.getItem) === 'function') {
    continue_without_support = window.localStorage.getItem(local_storage_key);
  }
} catch (err) {}


// This only checks for Safari, as it's the only browser that we have
// a minimum version requirement for at the moment.
// If it's not safari, we just assume the browser version is supported if the
// feature detection passes.
const isSupportedBrowserVersion = () => {
  const MIN_SAFARI_VERSION = 16;
  const { userAgent } = navigator;
  const safariMatch = userAgent.match(/Version\/(\d+)\.(\d+)(?:\.(\d+))? Safari/);
  if (safariMatch) {
    const majorVersion = parseInt(safariMatch[1], 10);
    return majorVersion >= MIN_SAFARI_VERSION;
  }
  return true; // If it's not Safari we return true
};


const required_features = (
  window.Modernizr
  && window.Modernizr.cssgrid
  && window.Modernizr.flexbox
  && window.Modernizr.mediaqueries
  && window.Modernizr.customproperties
  && window.Modernizr.intersectionobserver
  && window.Modernizr.requestanimationframe
  && window.ResizeObserver
  && isSupportedBrowserVersion()
);


const is_supported = required_features && window.FormData;
// NOTE: we always show the browser-not-supported view if cookies are disabled
if (!navigator.cookieEnabled || (!continue_without_support && !is_supported)) {
  window.addEventListener('DOMContentLoaded', () => {
    document.body.removeChild(document.getElementById('root'));

    const unsupported_view_div = document.getElementsByClassName('browser-not-supported-view')[0];
    if (unsupported_view_div) {
      const css_classes = [unsupported_view_div.getAttribute('class')];
      css_classes.push('show');
      css_classes.push(!navigator.cookieEnabled ? 'cookies-disabled' : 'unsupported-browser');
      unsupported_view_div.setAttribute('class', css_classes.join(' '));
    }

    // NOTE: the continue button is only shown in the unsupported-browser view
    // (if cookies are disabled you cannot continue to the app)
    if (navigator.cookieEnabled) {
      if (!supports_local_storage) {
        const continue_text = document.getElementsByClassName('continue-text')[0];
        continue_text.classList.add('hide');
      } else {
        const continue_button = document.getElementsByClassName('continue-button')[0];
        if (continue_button) {
          continue_button.addEventListener('click', () => {
            try {
              if (window.localStorage && typeof (window.localStorage.setItem) === 'function') {
                window.localStorage.setItem(local_storage_key, true);
              }
            } catch (err) {}
            window.location.reload();
          });
        }
      }
    }
  });
}
